import axiosConfig from "./axiosConfig";

interface DeleteHhDataResponse {
  success: boolean;
  message?: string;
}

const deleteHhData = async (
  authToken: string,
  fileGuid: string
): Promise<DeleteHhDataResponse> => {
  const { data } = await axiosConfig.delete(`/hh_data/${fileGuid}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default deleteHhData;
